import { render, staticRenderFns } from "./AssessmentViewDetails.vue?vue&type=template&id=6d6710f3&scoped=true"
import script from "./AssessmentViewDetails.vue?vue&type=script&lang=ts"
export * from "./AssessmentViewDetails.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentViewDetails.vue?vue&type=style&index=0&id=6d6710f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6710f3",
  null
  
)

export default component.exports